import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cc0028',
    ecrans: ['00-2']
});
